export default function Sobre() {
  return (
    <section id="sobre" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-[#B32025] rounded-lg opacity-30" />
            <div className="relative rounded-lg overflow-hidden" style={{ height: "520px" }}>
              <img
                src="https://readdy.ai/api/search-image?query=professional%20confident%20Brazilian%20male%20lawyer%20attorney%20dark%20navy%20suit%20standing%20in%20modern%20law%20office%20bookshelf%20legal%20books%20background%20warm%20professional%20lighting%20serious%20trustworthy%20expression%20high%20quality%20corporate%20photography%20clean%20minimal%20background&width=600&height=800&seq=sobre01&orientation=portrait"
                alt="Dr. Ivan Carlos – Advogado especialista em revisão de juros"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/60 via-transparent to-transparent" />
            </div>

            {/* Badge overlay */}
            <div className="absolute bottom-6 left-6 right-6 bg-white rounded-lg p-5">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#B32025]/10 rounded-lg flex-shrink-0">
                  <i className="ri-medal-line text-2xl text-[#B32025] leading-none" />
                </div>
                <div>
                  <p className="font-serif text-[#1A1A1A] font-bold text-base">Ivan Carlos</p>
                  <p className="text-[#B32025] text-sm font-semibold font-sans">Especialista em Revisão de Juros Abusivos</p>
                  <p className="text-[#2C2C2C]/60 text-xs font-sans">OAB/RS – Advogado</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="text-[#B32025] text-xs font-semibold uppercase tracking-widest font-sans">
              Sobre o Escritório
            </span>
            <h2 className="font-serif text-[#1A1A1A] text-3xl lg:text-4xl font-bold mt-3 mb-6">
              Advocacia com{" "}
              <em className="text-[#B32025] not-italic">propósito</em>{" "}
              e resultado
            </h2>

            <p className="text-[#2C2C2C]/80 text-base leading-relaxed font-sans mb-6">
              O <strong>Escritório Ivan Carlos Revisões de Juros</strong> nasceu com um propósito claro: colocar o conhecimento jurídico a serviço de quem enfrenta o peso das dívidas bancárias abusivas. Com sede em Nova Prata – RS, atendemos clientes em todo o Brasil com a mesma dedicação e compromisso.
            </p>

            <p className="text-[#2C2C2C]/80 text-base leading-relaxed font-sans mb-8">
              Nossa especialidade em <strong>revisão de juros abusivos</strong> é resultado de estudo técnico aprofundado e experiência prática em casos reais. Entendemos as complexidades dos contratos bancários e sabemos exatamente como identificar e combater abusos cometidos pelas instituições financeiras.
            </p>

            {/* Pillars */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
              {[
                { icon: "ri-book-open-line", label: "Conhecimento Técnico" },
                { icon: "ri-heart-line", label: "Compromisso Real" },
                { icon: "ri-user-voice-line", label: "Atendimento Direto" },
              ].map((p) => (
                <div key={p.label} className="flex flex-col items-center text-center p-4 bg-[#F9F9F9] rounded-lg">
                  <div className="w-10 h-10 flex items-center justify-center mb-2">
                    <i className={`${p.icon} text-2xl text-[#B32025] leading-none`} />
                  </div>
                  <span className="text-[#1A1A1A] text-xs font-semibold font-sans">{p.label}</span>
                </div>
              ))}
            </div>

            <div className="flex justify-center lg:justify-start">
              <a
                href="https://wa.me/5554996914900?text=Ol%C3%A1%2C%20gostaria%20de%20conhecer%20melhor%20o%20escritório."
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#B32025] hover:bg-[#8E1A1E] text-white font-semibold px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-base leading-none" />
                </div>
                Conversar com o advogado
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
